export default __webpack_public_path__ + "static/media/chevron_leftKeto.6a7eac63.svg";